export default {
  SUPER_ADMIN: 'super admin',
  AGENT: 'agent',
  SUPERVISOR: 'supervisor',
  MANAGEMENT: 'management',
  MANAGER: 'manager',
  API: 'api'
}
